import axiosInstance from "@/api/axiosInstance";

export interface CheckShareStatusRequest {
  employeeUuids: string[];
}

export interface CheckShareStatusResponse {
  sharedEmployeeUuids: string[];
}

export const checkShareStatus = async (
  resourceUuid: string,
  employeeUuids: string[],
): Promise<CheckShareStatusResponse> => {
  const response = await axiosInstance.post<{ data: CheckShareStatusResponse }>(
    `/api/private/resources/${resourceUuid}/check-share-status`,
    { employeeUuids },
  );
  return response.data.data;
};
